import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const useSubmitRefereeForm = (): {
  submitRefereeForm: (
    options?: MutationFunctionOptions,
  ) => Promise<FetchResult>;
  loading: boolean;
  error: any;
} => {
  // use update gql mutation to submit a referee form
  const [submitRefereeForm, { loading, error }] = useMutation(gql`
    mutation UpdateRefForm($input: UpdateRefFormInput!) {
      updateRefForm(input: $input)
    }
  `);
  return {
    submitRefereeForm,
    loading,
    error,
  };
};
